<template>
    <div class="view view--edit-wallpaper-category">
        <edit-wallpaper-category v-bind:id="id" />
    </div>
</template>

<script>
    import editWallpaperCategory from '../../../components/EditWallpaperCategory.vue';

    export default {
        components: {
            editWallpaperCategory
        },
        data: function () {
            return {
                id: parseInt(this.$route.params.category) || null
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/wallpapers/categories/Edit.vue